import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { OldSolutionsFail } from './components/OldSolutionsFail';
import { SolutionReveal } from './components/SolutionReveal';
import { MethodSection } from './components/MethodSection';
import { ResultsSection } from './components/ResultsSection';
import { ForWhomSection } from './components/ForWhomSection';
import { IdentityClose } from './components/IdentityClose';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-bg-main text-text-primary selection:bg-brand-gold/30 selection:text-brand-gold" data-id="element-0">
      <Hero data-id="element-1" />
      <PainSection data-id="element-2" />
      <OldSolutionsFail data-id="element-3" />
      <SolutionReveal data-id="element-4" />
      <MethodSection data-id="element-5" />
      <ResultsSection data-id="element-6" />
      <ForWhomSection data-id="element-7" />
      <IdentityClose data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}